import { useGetQualificationDisplayLabels } from "@src/appV2/Qualifications/api/useGetQualificationDisplayLabels";
import { intersection } from "lodash";

import { useGetWorkerLicensesAllowedForDocuments } from "./useGetWorkerLicensesAllowedForDocuments";
import { truncateQualifications } from "./utils/truncateQualifications";

interface UseGetRequirementApplicableQualificationsOptions {
  truncationLength?: number;
  truncationPrefix?: string;
}

export function useGetQualificationsForRequirement(
  qualifications: string[],
  options: UseGetRequirementApplicableQualificationsOptions = {}
) {
  const { licenses: availableLicenses } = useGetWorkerLicensesAllowedForDocuments();
  const applicableQualifications = intersection(qualifications, availableLicenses);

  const { truncationLength = 32, truncationPrefix } = options;

  const { data: qualificationDisplayLabels, isLoading } =
    useGetQualificationDisplayLabels(applicableQualifications);
  const distinctQualificationDisplayLabels = [...new Set(qualificationDisplayLabels)];
  const truncatedQualifications = truncateQualifications(
    distinctQualificationDisplayLabels,
    truncationLength,
    truncationPrefix
  );

  return {
    applicableQualifications,
    qualificationDisplayLabels: distinctQualificationDisplayLabels,
    truncatedQualifications,
    isLoading,
  };
}
